import {z} from 'zod';

import {useHelpLinks} from '../../provider/help-links/help-links-hook';
import {useUser} from '../../provider/user/user-hook';

import {HelpLinkFeatureFlagEnum} from './feature-flag-const';

const helpLinkFeatureFlagConfigSchema = z.object({
    available: z.boolean(),
    availableForStaff: z.boolean(),
    users: z.array(z.number()).optional(),
    brands: z.array(z.number()).optional(),
});

// `brandIds` opens a flag for whole brands: the caller passes the brands its screen works with —
// the company's own brand on a card, every brand the user can reach on a bulk screen.
export function useFeatureFlag(flag: HelpLinkFeatureFlagEnum, brandIds?: Array<number> | null): boolean {
    const helpLinks = useHelpLinks();
    const {user} = useUser();

    const flagLink = helpLinks.find((link) => link.urlPattern === flag);

    if (!flagLink) {
        return false;
    }

    const configResult = helpLinkFeatureFlagConfigSchema.safeParse(flagLink.config);

    if (!configResult.success) {
        return false;
    }

    const {available, availableForStaff, users, brands} = configResult.data;

    if (available) {
        return true;
    }

    if (availableForStaff && user?.isStaff) {
        return true;
    }

    if (user && users?.includes(user.id)) {
        return true;
    }

    return Boolean(brands?.length && brandIds?.some((brandId) => brands.includes(brandId)));
}
